module.exports = __webpack_public_path__ + "static/media/loader.594af4f5.svg";